// This file is auto-generated by scripts/generate-models.ts
// Do not edit manually - run 'npm run generate-models' to update

import type { Model } from "../types.ts";

export const XIAOMI_MODELS = {
	"mimo-v2-flash": {
		id: "mimo-v2-flash",
		name: "MiMo-V2-Flash",
		api: "openai-completions",
		provider: "xiaomi",
		baseUrl: "https://api.xiaomimimo.com/v1",
		compat: {"requiresReasoningContentOnAssistantMessages":true,"thinkingFormat":"deepseek"},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.14,
			output: 0.28,
			cacheRead: 0.0028,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 65536,
	} satisfies Model<"openai-completions">,
	"mimo-v2-omni": {
		id: "mimo-v2-omni",
		name: "MiMo-V2-Omni",
		api: "openai-completions",
		provider: "xiaomi",
		baseUrl: "https://api.xiaomimimo.com/v1",
		compat: {"requiresReasoningContentOnAssistantMessages":true,"thinkingFormat":"deepseek"},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.14,
			output: 0.28,
			cacheRead: 0.0028,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 131072,
	} satisfies Model<"openai-completions">,
	"mimo-v2-pro": {
		id: "mimo-v2-pro",
		name: "MiMo-V2-Pro",
		api: "openai-completions",
		provider: "xiaomi",
		baseUrl: "https://api.xiaomimimo.com/v1",
		compat: {"requiresReasoningContentOnAssistantMessages":true,"thinkingFormat":"deepseek"},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.435,
			output: 0.87,
			cacheRead: 0.0036,
			cacheWrite: 0,
		},
		contextWindow: 1048576,
		maxTokens: 131072,
	} satisfies Model<"openai-completions">,
	"mimo-v2.5": {
		id: "mimo-v2.5",
		name: "MiMo-V2.5",
		api: "openai-completions",
		provider: "xiaomi",
		baseUrl: "https://api.xiaomimimo.com/v1",
		compat: {"requiresReasoningContentOnAssistantMessages":true,"thinkingFormat":"deepseek"},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.14,
			output: 0.28,
			cacheRead: 0.0028,
			cacheWrite: 0,
		},
		contextWindow: 1048576,
		maxTokens: 131072,
	} satisfies Model<"openai-completions">,
	"mimo-v2.5-pro": {
		id: "mimo-v2.5-pro",
		name: "MiMo-V2.5-Pro",
		api: "openai-completions",
		provider: "xiaomi",
		baseUrl: "https://api.xiaomimimo.com/v1",
		compat: {"requiresReasoningContentOnAssistantMessages":true,"thinkingFormat":"deepseek"},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.435,
			output: 0.87,
			cacheRead: 0.0036,
			cacheWrite: 0,
		},
		contextWindow: 1048576,
		maxTokens: 131072,
	} satisfies Model<"openai-completions">,
	"mimo-v2.5-pro-ultraspeed": {
		id: "mimo-v2.5-pro-ultraspeed",
		name: "MiMo-V2.5-Pro-UltraSpeed",
		api: "openai-completions",
		provider: "xiaomi",
		baseUrl: "https://api.xiaomimimo.com/v1",
		compat: {"requiresReasoningContentOnAssistantMessages":true,"thinkingFormat":"deepseek"},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 1.305,
			output: 2.61,
			cacheRead: 0.0108,
			cacheWrite: 0,
		},
		contextWindow: 1048576,
		maxTokens: 131072,
	} satisfies Model<"openai-completions">,
} as const;
